export { basicToastMessage as toastMessage } from "./basic-toast"; // Export basicToastMessage as main toast message type
import { isBasicToastMessage } from "./basic-toast";
import { isCustomToastMessage } from "./custom-toast";
export var isToastMessage = function isToastMessage(m) {
  return isBasicToastMessage(m) || isCustomToastMessage(m);
};